import axios from '@/axios';

const RESOURCE_NAME = '/admin/crawl-ecosystems-startups';

export default {
    getLinkedList(botId) {
        return axios.post(`${RESOURCE_NAME}/get-linked-list?bot_id=${botId}`);
    },

    getNotLinkedList(botId) {
        return axios.post(`${RESOURCE_NAME}/get-not-linked-list?bot_id=${botId}`);
    },

    getCbList(ecosystemId) {
        return axios.post(`${RESOURCE_NAME}/get-cb-list?ecosystem_id=${ecosystemId}`);
    }
}
